/* rola.pet — dane i konfiguracja kalkulatora wagi i wielkości psa.

   WAŻNE: ten plik jest JEDYNYM miejscem z liczbami modelu. Logika (rola-growth.js)
   niczego nie wpisuje na sztywno — granice kategorii, krzywe, progi i zakresy ras
   czyta stąd. Dzięki temu można podmienić tabele bez ruszania kodu.

   STATUS DANYCH: "provisional" (wersja robocza).
   Krzywe poniżej to uśrednione, orientacyjne odsetki wagi dorosłej w zależności od wieku
   i kategorii wielkości (spójne z publicznie opisywanymi progami: np. ~50% wagi dorosłej
   w 3.–4. miesiącu u małych ras i w 5.–6. u dużych; koniec wzrostu 8–12 mies. u najmniejszych
   i do ~24 mies. u największych). NIE są to centyle WALTHAM / Royal Canin ani dane z Salt et al. 2017
   (tam wartości liczbowe krzywych nie są opublikowane tabelarycznie, tylko jako wykresy).

   Dopóki `validated` = false:
     - pewność wyniku jest ograniczona do poziomu "średnia",
     - alerty o odchyleniu trajektorii są wyłączone (alertsEnabled = false),
     - w opisie metodologii model jest nazwany orientacyjnym.
   Po wgraniu licencjonowanych tabel (format: curves + opcjonalnie centyle) ustaw
   validated = true, zaktualizuj sourceVersion / sourceNote i modelVersion.
*/
window.ROLA_GROWTH_DATA = {
  modelVersion: "2026-10-v0",
  sourceVersion: "provisional-percent-of-adult-weight-v0",
  sourceNote: "Orientacyjne krzywe odsetka wagi dorosłej wg wieku i kategorii wielkości (wersja robocza, do zastąpienia tabelami licencjonowanymi).",
  validated: false,
  alertsEnabled: false,

  /* granice wieku (dni) */
  minAgeDays: 56,    /* poniżej 8. tygodnia: tylko informacja edukacyjna */
  maxAgeDays: 730,   /* powyżej ~2 lat: pies dorosły */

  /* tolerancja zgodności oszacowania z zakresem (±20%) */
  tolerance: 0.2,

  /* skrajna niezgodność z rasą/rodzicami/kategorią: oszacowana waga dorosła powyżej
     (max zakresu × high) lub poniżej (min zakresu × low) → brak prognozy, prośba o sprawdzenie danych */
  severe: { high: 1.5, low: 0.6 },

  /* szerokość zakresu wyniku wg pewności (±) */
  spread: { low: 0.20, medium: 0.12, high: 0.08 },

  /* minimalny odstęp między ważeniami, żeby liczyły się jako osobne (dni) */
  minSessionGapDays: 7,

  /* kontrola skoku wagi: stosunek wzrostu zaobserwowanego do oczekiwanego */
  jump: { low: 0.6, high: 1.7, minGapDays: 7 },

  /* odchylenie trajektorii (używane tylko przy alertsEnabled = true) */
  trajectory: { low: 0.8, high: 1.25, minSessions: 3 },

  /* kiedy ważyć ponownie: do 26 tyg. co 2 tyg., do roku co 4 tyg., potem co 8 */
  nextWeighing: [
    { maxWeeks: 26,   days: 14 },
    { maxWeeks: 52,   days: 28 },
    { maxWeeks: 9999, days: 56 }
  ],

  /* kategorie wielkości — granice wagi dorosłej (kg) trzymane w konfiguracji, nie w froncie */
  categories: [
    { key: "toy",        label: "bardzo mały", range: [1, 6.5],  matureMonths: [8, 10],  ex: "np. chihuahua, yorkshire terrier, szpic miniaturowy" },
    { key: "small",      label: "mały",        range: [6.5, 9],  matureMonths: [9, 12],  ex: "np. shih tzu, jack russell terrier, jamnik miniaturowy" },
    { key: "medium",     label: "średni",      range: [9, 15],   matureMonths: [12, 14], ex: "np. beagle, mops, buldog francuski" },
    { key: "large",      label: "duży",        range: [15, 30],  matureMonths: [14, 18], ex: "np. border collie, husky, bokser" },
    { key: "very_large", label: "bardzo duży", range: [30, 40],  matureMonths: [16, 20], ex: "np. labrador, golden retriever, owczarek niemiecki" },
    { key: "giant",      label: "olbrzymi",    range: [40, 100], matureMonths: [18, 24], ex: "np. dog niemiecki, mastif, rottweiler", noForecast: true }
  ],

  /* krzywe: [wiek w tygodniach, ułamek wagi dorosłej]; między punktami interpolacja liniowa */
  curves: {
    toy:        [[8,.30],[10,.40],[12,.50],[16,.63],[20,.74],[24,.82],[28,.88],[32,.93],[36,.96],[40,.98],[44,.99],[52,1]],
    small:      [[8,.26],[10,.34],[12,.42],[16,.55],[20,.66],[24,.75],[28,.82],[32,.88],[36,.92],[40,.95],[44,.97],[52,.99],[60,1]],
    medium:     [[8,.20],[10,.27],[12,.34],[16,.47],[20,.58],[24,.68],[28,.76],[32,.82],[36,.87],[40,.91],[44,.94],[52,.97],[60,.99],[68,1]],
    large:      [[8,.16],[10,.21],[12,.28],[16,.40],[20,.51],[24,.61],[28,.69],[32,.76],[36,.82],[40,.86],[44,.90],[52,.94],[60,.97],[68,.99],[78,1]],
    very_large: [[8,.14],[10,.19],[12,.25],[16,.36],[20,.46],[24,.55],[28,.63],[32,.70],[36,.76],[40,.81],[44,.85],[52,.90],[60,.94],[68,.97],[78,.99],[90,1]]
  },

  /* typowe zakresy wagi dorosłej (kg, oba płcie) — orientacyjne, na podstawie wzorców ras; do weryfikacji */
  breeds: [
    { n: "Akita (akita inu)", r: [32, 50] },
    { n: "Alaskan malamute", r: [34, 43] },
    { n: "Amerykański staffordshire terier", r: [18, 32] },
    { n: "Basset hound", r: [18, 27] },
    { n: "Beagle", r: [9, 14] },
    { n: "Berneński pies pasterski", r: [35, 55] },
    { n: "Bichon frisé", r: [5, 8] },
    { n: "Bokser", r: [24, 36] },
    { n: "Border collie", r: [14, 20] },
    { n: "Bostoński terier", r: [4.5, 11] },
    { n: "Buldog angielski", r: [22, 28] },
    { n: "Buldog francuski", r: [8, 14] },
    { n: "Cairn terier", r: [6, 8] },
    { n: "Cane corso", r: [40, 50] },
    { n: "Cavalier king charles spaniel", r: [5.5, 8] },
    { n: "Chihuahua", r: [1.5, 3] },
    { n: "Chow chow", r: [20, 32] },
    { n: "Cocker spaniel angielski", r: [12, 16] },
    { n: "Collie (owczarek szkocki długowłosy)", r: [18, 30] },
    { n: "Dalmatyńczyk", r: [20, 32] },
    { n: "Doberman", r: [27, 45] },
    { n: "Dog niemiecki", r: [45, 90] },
    { n: "Golden retriever", r: [25, 34] },
    { n: "Husky syberyjski", r: [16, 27] },
    { n: "Jack russell terrier", r: [5, 8] },
    { n: "Jamnik miniaturowy", r: [3.5, 6] },
    { n: "Jamnik standardowy", r: [7, 14] },
    { n: "Labrador retriever", r: [25, 36] },
    { n: "Lhasa apso", r: [5, 8] },
    { n: "Maltańczyk", r: [2.5, 4] },
    { n: "Mastif angielski", r: [55, 90] },
    { n: "Mops", r: [6, 9] },
    { n: "Nowofundland", r: [45, 70] },
    { n: "Owczarek australijski", r: [16, 29] },
    { n: "Owczarek belgijski (malinois)", r: [20, 34] },
    { n: "Owczarek niemiecki", r: [22, 40] },
    { n: "Owczarek podhalański", r: [30, 50] },
    { n: "Owczarek szetlandzki (sheltie)", r: [6, 11] },
    { n: "Pekińczyk", r: [3, 6] },
    { n: "Pinczer miniaturowy", r: [3.5, 6] },
    { n: "Pomeranian (szpic miniaturowy)", r: [1.8, 3.5] },
    { n: "Pudel duży (królewski)", r: [20, 32] },
    { n: "Pudel miniaturowy", r: [4, 8] },
    { n: "Pudel średni", r: [7, 12] },
    { n: "Rottweiler", r: [35, 60] },
    { n: "Samojed", r: [17, 30] },
    { n: "Setter irlandzki", r: [24, 32] },
    { n: "Shiba inu", r: [8, 11] },
    { n: "Shih tzu", r: [4.5, 8] },
    { n: "Staffordshire bull terier", r: [11, 17] },
    { n: "Sznaucer miniaturowy", r: [4.5, 7] },
    { n: "Sznaucer olbrzym", r: [25, 48] },
    { n: "Sznaucer średni", r: [14, 20] },
    { n: "Terier szkocki", r: [8, 10.5] },
    { n: "Weimaraner", r: [25, 40] },
    { n: "West highland white terier", r: [6, 10] },
    { n: "Whippet", r: [9, 18] },
    { n: "Wyżeł niemiecki krótkowłosy", r: [20, 32] },
    { n: "Yorkshire terier", r: [2, 3.2] }
  ]
};
